/**
 * A `Try again` action retries the last request. This is the one retry path
 * both the manual tap and any future caller should use, so it is never
 * re-implemented per screen.
 */
import type { QueryClient } from "@tanstack/react-query";

export async function retryAfterOffline(
  queryClient: QueryClient,
): Promise<void> {
  await queryClient.resumePausedMutations();
  await queryClient.refetchQueries({ type: "active" });
}
